import { BillDetail } from "@features/JointBillList/components/JointBillPeriod/components/JointBill/components/JointBillTable/components/ProviderBill/components/BillDetails/components/BillDetail/BillDetail";
import {
  type IBillData,
  type IBillDetail,
  type IOverviewJointBillService,
} from "@services/overview/types";

interface IBillDetailsProps {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  jointBillServiceAgreementId: IBillData["jointBillServiceAgreementId"];
  periodId: number;
  billDetails: IBillDetail[];
  currency: IBillData["currencyId"];
  isBillDataExpectedPaymentEditable: IBillData["expectedPaymentIsEditable"];
}

export const BillDetails: React.FC<IBillDetailsProps> = ({
  jointBillServiceId,
  jointBillServiceAgreementId,
  periodId,
  billDetails,
  currency,
  isBillDataExpectedPaymentEditable,
}) => {
  return (
    <div className="flex flex-col divide-y divide-grey-light">
      {billDetails.map((billDetail) => (
        <BillDetail
          key={billDetail.billDetailId}
          jointBillServiceId={jointBillServiceId}
          jointBillServiceAgreementId={jointBillServiceAgreementId}
          periodId={periodId}
          billDetail={billDetail}
          currency={currency}
          isBillDataExpectedPaymentEditable={isBillDataExpectedPaymentEditable}
        />
      ))}
    </div>
  );
};
